import { useMemo } from "react";
import { Box, Text, BoxProps, TextProps } from "@chakra-ui/react";

export const BookCard: React.FC<BoxProps> = ({
  children,
  maxW = 800,
  ...props
}) => {
  return (
    <Box
      {...props}
      p={{ base: 4, lg: 6 }}
      pb={6}
      w="full"
      maxW={maxW}
      bg={"white"}
      border={"1px solid #E5E5E5"}
      borderRadius={"2xl"}
    >
      {children}
    </Box>
  );
};

type BookCardTitleProps = TextProps & {
  small?: boolean;
};
export const BookCardTitle: React.FC<BookCardTitleProps> = ({
  small,
  ...styles
}) => {
  const fontSize = useMemo(
    () => (small ? { base: "16px", lg: "18px" } : { base: "20px", lg: "28px" }),
    [small]
  );
  return (
    <Text
      color={"#202020"}
      fontSize={fontSize}
      lineHeight={"35px"}
      fontFamily={"Cairo"}
      fontWeight={"bold"}
      {...styles}
    />
  );
};

type BookCardSubtitleProps = TextProps & {
  small?: boolean;
};
export const BookCardSubtitle: React.FC<BookCardSubtitleProps> = ({
  small,
  ...styles
}) => {
  const fontSize = useMemo(
    () => (small ? "16px" : { base: "16px", lg: "18px" }),
    [small]
  );
  return (
    <Text
      color={"#A5A5A5"}
      fontSize={fontSize}
      lineHeight={"15px"}
      fontFamily={"Open Sans"}
      {...styles}
    />
  );
};
